module.exports = __webpack_public_path__ + "static/13-891c617f4bce801cd88af5253c1c84ab.jpg";